import React from "react";
import bannerSvg from "../assets/Images/download.svg";
import { useService } from "../ServiceContext";
const ServiceBanner = () => {
  const { service } = useService();
  return (
    <div
      data-aos="fade-up"
      className="w-full flex justify-center items-center px-2 md:px-0"
    >
      <div className="2xl:w-3/4 3xl:w-2/3 xl:w-[90%] w-[95%] h-[380px] md:h-[300px] lg:h-[350px] flex md:px-[60px] px-8   lg:px-[72px] items-center rounded-3xl mt-8 bg-verylightGreen relative overflow-hidden">
        <div className="absolute bottom-0 right-0 lg:top-10 xl:top-0  xl:right-0 md:-right-5 lg:pt-5 xl:pt-0">
          <img
            src={bannerSvg}
            alt="banner-img"
            className="md:w-40 w-[6.65rem] lg:w-auto"
          />
        </div>
        <div className="flex md:flex-row flex-col gap-6 w-[668px]">
          <div className="w-[120px] h-[120px] flex-shrink-0 rounded-full flex justify-center items-center bg-[#fcf5ec]">
            <img src={service.Icon} alt="service-img" />
          </div>
          <div>
            <h1
              className="lg:text-[58px] md:text-[48px] text-[36px] leading-[1.138em] font-heading text-thickGreen  mb-4"
              data-aos-easing="ease-in-back"
              data-aos-delay="100"
              data-aos-offset="0 "
              data-aos="fade-right"
            >
              {service.title}
            </h1>
            <p data-aos-easing="ease-in-back"
              data-aos-delay="200"
              data-aos-offset="0 "
              data-aos="fade-right" className="md:text-[18px] text-[16px] font-body text-paraGreen font-[500]">
              {service.description}
            </p>
          </div>
        </div>
        
      </div>



    </div>
  );
};

export default ServiceBanner;
